(() => {
  const FAQ_HEADING = 'frequently asked questions';

  function enhance(section) {
    if (section.dataset.bvtSeoLayoutEnhanced === 'true') return;

    const directChildren = Array.from(section.children);
    const heading = directChildren.find((node) => node.tagName === 'H2');
    const faqHeading = directChildren.find(
      (node) => node.tagName === 'H3' && node.textContent.trim().toLowerCase() === FAQ_HEADING
    );
    const related = directChildren.find(
      (node) => node.tagName === 'NAV' && node.getAttribute('aria-label') === 'Related collections'
    );

    if (!heading) return;

    const lead = document.createElement('div');
    lead.className = 'bvt-collection-seo-lead';
    const leadCopy = document.createElement('div');
    leadCopy.className = 'bvt-collection-seo-lead-copy';
    const topics = document.createElement('div');
    topics.className = 'bvt-collection-seo-topics';

    heading.before(lead);
    lead.append(heading, leadCopy);

    let currentTopic = null;
    let node = lead.nextElementSibling;
    while (node && node !== faqHeading && node !== related) {
      const next = node.nextElementSibling;
      if (node.tagName === 'H3') {
        currentTopic = document.createElement('article');
        currentTopic.className = 'bvt-collection-seo-topic';
        topics.append(currentTopic);
        currentTopic.append(node);
      } else if (currentTopic) {
        currentTopic.append(node);
      } else {
        leadCopy.append(node);
      }
      node = next;
    }

    if (topics.children.length) {
      lead.after(topics);
    }

    if (faqHeading) {
      const faqGroup = document.createElement('details');
      faqGroup.className = 'bvt-collection-seo-faq-group';
      const summary = document.createElement('summary');
      const title = document.createElement('h3');
      title.className = 'bvt-collection-seo-faq-title';
      title.textContent = 'FAQs';
      const icon = document.createElement('span');
      icon.className = 'bvt-collection-seo-faq-icon';
      icon.setAttribute('aria-hidden', 'true');
      summary.append(title, icon);

      const faqList = document.createElement('div');
      faqList.className = 'bvt-collection-seo-faq-list';
      faqHeading.before(faqGroup);
      faqGroup.append(summary, faqList);
      faqHeading.remove();

      let faqNode = faqGroup.nextElementSibling;
      while (faqNode && faqNode !== related) {
        const next = faqNode.nextElementSibling;
        if (faqNode.tagName === 'DETAILS') faqList.append(faqNode);
        faqNode = next;
      }
    }

    if (related) related.classList.add('bvt-collection-seo-related');
    section.dataset.bvtSeoLayoutEnhanced = 'true';
  }

  function init(root = document) {
    root.querySelectorAll('.bvt-collection-seo-shell .bvt-collection-seo-content').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
